import { render, staticRenderFns } from "./AlipayAuth.vue?vue&type=template&id=5ef62238&scoped=true"
import script from "./AlipayAuth.vue?vue&type=script&lang=js"
export * from "./AlipayAuth.vue?vue&type=script&lang=js"
import style0 from "./AlipayAuth.vue?vue&type=style&index=0&id=5ef62238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef62238",
  null
  
)

export default component.exports